import { useMemo } from 'react';
import type { ComponentType } from 'react';
import type { ColDef, ICellRendererParams } from 'ag-grid-community';
import type { IPerson } from '../../../models/person/PersonModel';

export function usePersonsColumnDefs(
  actionCellRenderer: ComponentType<ICellRendererParams<IPerson>>
): ColDef<IPerson>[] {
  return useMemo<ColDef<IPerson>[]>(
    () => [
      {
        headerName: 'İşlemler',
        cellRenderer: actionCellRenderer,
        width: 120,
        sortable: false,
        filter: false,
        pinned: 'left',
      },
      {
        field: 'name',
        headerName: 'İsim',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'hospitalName',
        headerName: 'Hastane',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'phoneNumber',
        headerName: 'Telefon Numarası',
        flex: 1,
        minWidth: 150,
        filter: true,
        sortable: true,
      },
      {
        field: 'email',
        headerName: 'E-mail',
        flex: 1,
        minWidth: 200,
        filter: true,
        sortable: true,
      },
    ],
    [actionCellRenderer]
  );
}

export function usePersonsDefaultColDef(): ColDef<IPerson> {
  return useMemo(
    () => ({
      resizable: true,
      sortable: true,
      filter: true,
    }),
    []
  );
}

